import React from "react";

export const RequestProjectExpenseModal = ({
  isOpen,
  onClose,
  project,
  onSuccess,
}) => {
  if (!project?._id) return null;

  return null;
};
